import { render, staticRenderFns } from "./MulVideoEdit.vue?vue&type=template&id=6656dfc4"
import script from "./MulVideoEdit.vue?vue&type=script&lang=js"
export * from "./MulVideoEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports